/**
 * Referral capability keys — the EXACT server capability strings (verified against
 * server/src/modules/referral/routes.js, role-gated via protectedRoute({ capability })). useCan / nav
 * gating / ProtectedRoute all key off these. The server re-checks every request; these only hide/disable
 * UI (never the trust boundary).
 *
 * Endpoint → capability (all under /api/v1):
 *   POST /referral/medecins/inviter      referral.lien.manage
 *   POST /referral/liens/decision        referral.lien.manage
 *   POST /referral/liens/:id/revoquer    referral.lien.manage
 *   POST /referral/codes                 referral.code.manage
 *   POST /referral/codes/:id/toggle      referral.code.manage
 *   GET  /referral/candidate             referral.remise.set
 *   GET  /referral/retours               referral.retour.read
 *   GET  /referral/analytics             referral.analytics.read
 */
export const REF_CAPS = {
  /** Manage the lab↔médecin link: invite, apply decision, revoke. */
  lienManage: "referral.lien.manage",
  /** CodeReferral CRUD (create + actif↔inactif toggle). */
  codeManage: "referral.code.manage",
  /** Read the discount candidate resolver (also gates the per-code candidate probe). */
  remiseSet: "referral.remise.set",
  /** Read the prescriber-return tracking rows. */
  retourRead: "referral.retour.read",
  /** Read the per-médecin referral analytics cards (also the link-table roster source). */
  analyticsRead: "referral.analytics.read",
} as const;

export type ReferralCapability = (typeof REF_CAPS)[keyof typeof REF_CAPS];
